import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const PageContainer = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(4)
}));

export const PageHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(3)
}));

export const YearTagsRow = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 12,
  marginBottom: 16
}));

export const FileListContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column'
}));

export const FileItemRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingTop: theme.spacing(1), // 8px
  paddingBottom: theme.spacing(1), // 8px
  cursor: 'pointer'
}));

export const FileItemInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5), // 4px
  flex: 1,
  minWidth: 0,
  overflow: 'hidden'
}));

export const FileItemName = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2R,
  color: theme.palette.neutrals.lead,
  whiteSpace: 'nowrap',
  maxWidth: 220
}));

export const FileItemDate = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.neutrals.lead
}));

export const FileDownloadLink = styled('a')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  textDecoration: 'none',
  color: 'inherit',
  flexShrink: 0
}));

export const EmptyStateText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2R,
  color: theme.palette.neutrals.beige4,
  textAlign: 'center',
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(2)
}));

export const FeedbackToast = styled(Box)(({ theme }) => ({
  ...theme.typography.body2B,
  backgroundColor: theme.palette.colored.purple,
  color: theme.palette.neutrals.beige1,
  borderRadius: 8,
  boxShadow: '4px 4px 2px rgba(0,0,0,0.1)',
  padding: '10px 17px',
  width: 280,
  textAlign: 'center'
}));
